import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageAnyoPacksComponent } from './manage-anyo-packs/manage-anyo-packs.component';
import { CurdAnyoPacksComponent } from './curd-anyo-packs/curd-anyo-packs.component';
import { AnyoPacksSubscriptionComponent } from './anyo-packs-subcription/anyo-packs-subcription.component';
import { PacksSubscriptionComponent } from './packs-subscription/packs-subscription.component';
import { TemplateCheckComponent } from './template-check/template-check.component';

const routes: Routes = [
  {
    path: '',
    component: ManageAnyoPacksComponent,
  },
  {
    path: 'curd',
    component: CurdAnyoPacksComponent,
  },
  {
    path: 'curd/:id',
    component: CurdAnyoPacksComponent,
  },
  {
    path: 'packs-subscription',
    component: AnyoPacksSubscriptionComponent,
  },
  {
    path: 'subscription',
    component: PacksSubscriptionComponent,
  },
  {
    path: "chat",
    component: TemplateCheckComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PacksRoutingModule {}
